// UK census and population estimates used for panel index calculations.
// Index 100 = panel composition matches census (parity).
//
// Age / gender: ONS 2021 Census (England, Wales, Scotland, Northern Ireland) — adults 18+
// Geography:    ONS mid-2023 local authority estimates mapped to postcode areas
//               (UK_POP_TOTAL_K = 67,500k — approximate UK all-ages total)

// % of the TOTAL (all-ages) population per age band — ONS 2021 Census, England &
// Wales (actual population share, NOT re-based to 18+). Verified 2026-09-14 against
// Nomis TS007; all-ages total = 59,597,546. Adult bins below sum to ~79.2%
// (remaining ~20.8% is under-18).
//   0-17  = 12,392,218 | 18-24 = 4,957,270 | 25-34 = 8,050,540 | 35-44 = 7,737,374
//   45-54 = 7,912,154  | 55-64 = 7,484,645 | 65+   = 11,063,345
// 0-17 has no panel equivalent (panel is 18+), so its Panel Share bar is left empty.
export const UK_CENSUS_AGE_PCT = {
  '0-17':    20.79,
  '18-24':   8.32,
  '25-34':   13.51,
  '35-44':   12.98,
  '45-54':   13.28,
  '55-64':   12.56,
  'Over 65': 18.56,
  'Unknown': null,   // no census equivalent
};

// % of UK population per gender — ONS 2021 Census
export const UK_CENSUS_GENDER_PCT = {
  M: 48.9,
  F: 51.1,
  U: null,
};

// Population by postcode area (thousands) — ONS mid-2023 estimates
const GEO_POP_K = {
  AB: 290,  AL: 170,  B: 1270,  BA: 330,  BB: 370,  BD: 540,  BH: 410,  BL: 270,
  BN: 480,  BR: 335,  BS: 700,  BT: 750,  CA: 170,  CB: 395,  CF: 580,  CH: 390,
  CM: 520,  CO: 390,  CR: 385,  CT: 420,  CV: 380,  CW: 190,  DA: 310,  DD: 155,
  DE: 410,  DG: 150,  DH: 265,  DL: 260,  DN: 370,  DT: 145,  DY: 310,  E:  840,
  EC: 10,   EH: 490,  EN: 330,  EX: 345,  FK: 155,  FY: 310,  G:  620,  GL: 310,
  GU: 385,  GY: 63,   HA: 250,  HD: 415,  HG: 165,  HP: 270,  HR: 190,  HS: 27,
  HU: 320,  HX: 200,  IG: 290,  IM: 85,   IP: 340,  IV: 120,  JE: 107,  KA: 370,
  KT: 170,  KW: 26,   KY: 365,  L:  490,  LA: 250,  LD: 75,   LE: 570,  LL: 300,
  LN: 310,  LS: 800,  LU: 235,  M:  540,  ME: 280,  MK: 270,  ML: 320,  N:  470,
  NE: 960,  NG: 730,  NN: 380,  NP: 240,  NR: 430,  NW: 450,  OL: 370,  OX: 375,
  PA: 310,  PE: 385,  PH: 150,  PL: 380,  PO: 670,  PR: 430,  RG: 360,  RH: 265,
  RM: 345,  S:  700,  SA: 410,  SE: 640,  SG: 215,  SK: 310,  SL: 245,  SM: 200,
  SN: 290,  SO: 490,  SP: 200,  SR: 275,  SS: 330,  ST: 470,  SW: 460,  SY: 310,
  TA: 185,  TD: 97,   TF: 170,  TN: 360,  TQ: 130,  TR: 175,  TS: 470,  TW: 270,
  UB: 240,  W:  380,  WA: 430,  WC: 15,   WD: 200,  WF: 360,  WN: 330,  WR: 295,
  WS: 275,  WV: 270,  YO: 270,  ZE: 23,
};

const UK_POP_TOTAL_K = 67500;

// % of UK population per postcode area
export const UK_CENSUS_GEO_PCT = Object.fromEntries(
  Object.entries(GEO_POP_K).map(([k, v]) => [k, +((v / UK_POP_TOTAL_K) * 100).toFixed(4)])
);

export const CENSUS_SOURCE =
  'Age & gender: ONS 2021 Census (UK adults 18+). ' +
  'Geography: ONS mid-2023 population estimates by postcode area (UK total ≈ 67.5M).';
